export type TTheme = {
  colors: {
    font: string;
    fontLight: string;
    primary: string;
    accent: string;
    grey: string;
    inputBg: string;
    error: string;
    success: string;
  };
};

const theme: TTheme = {
  colors: {
    font: '#181E34',
    fontLight: 'rgba(24, 30, 52, 0.5)',
    primary: '#6AD5E5',
    accent: '#FF4496',
    grey: '#e1e2e8',
    inputBg: '#efeff3',
    error: '#FF335C',
    success: '#6AE59F',
  },
};

export const FIXED_DIMENSIONS = {
  headerHeight: 60,
  headerZIndex: 99999,
  sideBarWidth: 190,
} as const;

export default theme;
